import { render, staticRenderFns } from "./NextPrevBtn.vue?vue&type=template&id=324a1528&"
import script from "./NextPrevBtn.vue?vue&type=script&lang=ts&"
export * from "./NextPrevBtn.vue?vue&type=script&lang=ts&"
import style0 from "./NextPrevBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports